import React, { useRef, useState } from 'react';
import s from './Reviews.module.scss';
import { ReactComponent as PlayIcon } from 'images/new-icons/play-icon.svg';
import { ReactComponent as PauseIcon } from 'images/new-icons/search-black.svg';
import { ReactComponent as VolumeIcon } from 'images/new-icons/grey-star.svg';

const VideoPlayer = ({ src }: { src: string }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [volume, setVolume] = useState(1);

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleProgress = () => {
    if (videoRef.current) {
      const currentProgress =
        (videoRef.current.currentTime / videoRef.current.duration) * 100;
      setProgress(currentProgress);
    }
  };

  const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (videoRef.current) {
      videoRef.current.volume = newVolume;
    }
  };

  const handleSeek = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (videoRef.current) {
      const newTime = (parseFloat(e.target.value) / 100) * videoRef.current.duration;
      videoRef.current.currentTime = newTime;
      setProgress(parseFloat(e.target.value));
    }
  };

  return (
    <div className={s.videoPlayer}>
      <video
        ref={videoRef}
        src={src}
        className={s.video}
        onTimeUpdate={handleProgress}
        onEnded={() => setIsPlaying(false)}
      />
      <div className={s.controls}>
        <button onClick={togglePlayPause} className={s.playPauseButton}>
          {!isPlaying && <PlayIcon />}
        </button>
        
      </div>
    </div>
  );
};

export default VideoPlayer;
